import type { NumbersObjectNullable } from '@/types'

export const isRecordUnknown = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

export const isRecordNumberOrNull = (value: unknown): value is NumbersObjectNullable =>
  isRecordUnknown(value) && Object.entries(value).every(([_, item]) => Number.isInteger(item) || item === null)
